import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import base64ToFile from "../../../../services/base64ToFile";
import ErrorMessage from "../../../../components/ErrorMessage";

const StakeholderUpdateCard = ({stakeholder, onDelete, schema, onUpdate}) => {
  const {id, titleEn, iconBase64, iconTag} = stakeholder;
  const [imagePreview, setImagePreview] = useState(`data:image/jpeg;base64,${iconBase64}`);
  const [imageTag, setImageTag] = useState(iconTag);

  const {
    register,
    handleSubmit,
    setValue,
    formState: {errors},
  } = useForm({
    resolver: zodResolver(schema),
    initialValue: stakeholder,
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setValue("iconBase64", file);
    setImageTag(file.name);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (data) => {
    const {titleEn, iconBase64} = data;
    console.log({titleEn, iconBase64, imageTag});

    const formData = new FormData();
    formData.append("titleEn", titleEn);
    formData.append("icon", iconBase64);
    formData.append("iconTag", imageTag);

    onUpdate(formData, id);
  };

  useEffect(() => {
    setValue("titleEn", titleEn);
    setValue("iconBase64", base64ToFile(imagePreview));
    setValue("iconTag", iconTag);
  }, []);


  return (
      <div className="stakeholder-card" style={{height: '350px'}}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <header className="card-header">
            <div className="image-uploader">
              <label className="icon-update-btn" htmlFor={`uploader${id}`}>
                <i className="fa fa-pencil"></i>
              </label>
              <input
                  id={`uploader${id}`}
                  className="d-none"
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/webp"
                  {...register("iconBase64", {onChange: handleImageChange})}
              />
            </div>
            <img src={imagePreview} alt={imageTag}/>
          </header>
          <ErrorMessage message={errors?.iconBase64?.message}/>
          <div className="mt-3">
            <div className="form__div-container">
              <div className="form__div">
                <input
                    type='text'
                    className="form__input"
                    {...register("titleEn")}
                />
                <label htmlFor="" className="form__label">Title</label>
              </div>
              <ErrorMessage message={errors?.titleEn?.message}/>
            </div>
          </div>
          <div className="">
            <div className=" d-flex justify-content-center">
              <button
                  onClick={() => onDelete(id)}
                  type="button"
                  className="delete-btn">
                Delete
              </button>
              <button
                  type="submit"
                  className="save-btn ml-2">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
  );
};

export default StakeholderUpdateCard;
